import { TFunction } from "i18next";
import * as yup from "yup";
import { ValidationMessagesUtils } from "../../../utils/yup";

export default function createAssemblySchema(t: TFunction) {
  return yup.object().shape({
    name: yup
      .string()
      .required(
        ValidationMessagesUtils.createRequiredMessage(t, "common.name")
      ),
    UOM: yup
      .string()
      .required(
        ValidationMessagesUtils.createRequiredMessage(
          t,
          "takeOffSection.measurement"
        )
      ),
    items: yup.array().of(
      yup.object().shape({
        cost: yup
          .string()
          .required(
            ValidationMessagesUtils.createRequiredMessage(t, "costing.cost")
          ),
        quantity: yup
          .string()
          .required(
            ValidationMessagesUtils.createRequiredMessage(t, "costing.quantity")
          ),
        UOM: yup
          .string()
          .required(
            ValidationMessagesUtils.createRequiredMessage(t, "costing.uom")
          ),
        name: yup
          .string()
          .required(
            ValidationMessagesUtils.createRequiredMessage(t, "common.name")
          ),
      })
    ),
  });
}
